import { Button, Container, Form } from 'react-bootstrap';
import { useState } from 'react';

import { db } from '../../ReactNative/firebase';
import { child, get, ref } from 'firebase/database';
import { useNavigate } from 'react-router-dom';

const Prim = () => {
    const [name, setName] = useInput({type: 'text'})
    const [email, setEmail] = useInput({ type: 'email'})
    const navigate = useNavigate()

    function useInput({ type }) {
        const [value, setValue] = useState("");
        const input = <input value={value} onChange={e => setValue(e.target.value)} type={type} />
        return [value, input];
    }

    const startQuiz = (e) => {
        e.preventDefault();
    
        if (!name) {
            alert("Please type your name first.");
            return;
        }
    
        if (!email) {
            alert("Please type your email, too.");
            return;
        }
    
        const startTime = Date.now();
    
        sessionStorage.setItem('PrimTriviaStartTime', startTime);
        sessionStorage.setItem('PrimTriviaEmail', email);
        sessionStorage.setItem('PrimTriviaName', name);
        sessionStorage.setItem('PrimTriviaStarted', 'true');
    
        const dbRef = ref(db);
    
        get(child(dbRef, 'PrimTriviaScoreboard/')).then(snap => {
            let foundEmail = false;
    
            const data = snap.val() || [];
    
            for (let i = 0; i < data.length; i++) {
                if (
                    email.toLowerCase() === data[i]?.email?.toLowerCase()
                ) {
                    alert("You already took the quiz with this email.");
                    foundEmail = true;
                    break;
                }
            }
    
            if (!foundEmail) {
                navigate('/QuizTrivias/June2026/primtrivia');
            }
        });
    };

    return (
            <>
                <Container className="keiki-party prim-7th">

                <h1 className="prim-entry-title ycustom-banner neonText-purple text-center">
                    <s></s>Prim's 7th Trivia
                </h1>

                <div className="prim-entry-wrapper">

                    <div className="prim-entry-card">

                        <Form onSubmit={startQuiz} className="prim-entry-form">

                            <h3 className="prim-entry-subtitle">
                                Before taking it, please fill out info:
                            </h3>

                            <div className="prim-input-group">
                                <Form.Label>Name:</Form.Label>
                                <div className="prim-input">
                                    {setName}
                                </div>
                            </div>

                            <div className="prim-input-group">
                                <Form.Label>Email:</Form.Label>
                                <div className="prim-input">
                                    {setEmail}
                                </div>
                            </div>

                            <Button type="submit" className="prim-start-btn">
                                Start Trivia
                            </Button>

                        </Form>

                    </div>

                </div>

                </Container>
            </>
    )
}

export default Prim;